import { useState } from 'react';
import { useRecoilValue } from 'recoil';

import CharterFlightSearch from '@Components/Home/Drilldowns/CharterFlightSearch';
import CharterCompanySearch from '@Components/Home/Drilldowns/CharterCompanySearch';
import EmptyLegSearch from '@Components/Home/Drilldowns/EmptyLegSearch';
import KeywordSearch from '@Components/Home/Drilldowns/KeywordSearch';
import atoms from '@Components/Utilities/SandhillsAtoms';
import translator from '@Components/Utilities/Translator';

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
function DrillTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <>
            {value == index &&
                <div
                    className="drill-content"
                    id={`simple-tabpanel-${index}`}
                    aria-labelledby={`simple-tab-${index}`}
                    {...other}
                >
                    <div className='search-container'>
                        {children}
                    </div>
                </div>}
        </>
    );
}

const DrilldownTabPanel = (props) => {
    const [active, setActive] = useState(0);
    const routes = useRecoilValue(atoms.routes);

    const handleChange = (newValue) => {
        setActive(newValue);
    };

    const DrillButton = (props) => {
        const { index, title } = props;
        return (
            <a
                role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleChange(index); } }} 
                className={`ts-button drill-button ${active === index ? 'active' : ''}`}
                id={`btn-${index}`}
                onClick={() => handleChange(index)}
                {...a11yProps(0)}>{title}
            </a>
        );
    } 

    return (
        <div className="search-container">
            <h2>{translator.translate('sandhills.tradesites.mvc.searchforcharterhubtext')}</h2>
            <div className="drill-container">
                <div className="drill-buttons">
                    <DrillButton index={0} title={'Charters'} />
                    <DrillButton index={1} title={'Empty Legs'} />
                    <DrillButton index={2} title={'Charter Companies'} />
                    <DrillButton index={3} title={'FBOs'} />
                    <DrillButton index={4} title={'Keywords'} />
                </div>
                <DrillTabPanel value={active} index={0}>
                    <CharterFlightSearch searchURL={routes.Listings + '/search?'} IsMetric={props.IsMetric} />
                </DrillTabPanel>
                <DrillTabPanel value={active} index={1}>
                    <EmptyLegSearch searchURL={routes.EmptyLegsDirectory} IsMetric={props.IsMetric} />
                </DrillTabPanel>
                <DrillTabPanel value={active} index={2}>
                    <CharterCompanySearch GetCountryDropDown={props.GetCountryDropDownByCode} searchURL={routes.DealerDirectorySearch} IsMetric={props.IsMetric} />
                </DrillTabPanel>
                <DrillTabPanel value={active} index={3}>
                    <CharterCompanySearch GetCountryDropDown={props.GetCountryDropDown} searchURL={routes.FBO + "/aircraft-charter-companies/"} IsMetric={props.IsMetric} />
                </DrillTabPanel>
                <DrillTabPanel value={active} index={4}>
                    <KeywordSearch />
                </DrillTabPanel>
            </div>
        </div>
    );
}

export default DrilldownTabPanel;